var _circle, _circle2, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "url(#paint0_linear_462_16814)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_462_16814",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9512,
    cy: 14.3897,
    r: 9.56348,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_462_16814)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.4419,
    cy: 13.3701,
    r: 9.56348,
    fill: "url(#paint1_linear_462_16814)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8555 6.39453L16.1055 10.8945L20.6055 11.457L17.5155 14.922L18.3555 19.8945L13.8555 17.6445L9.35547 19.8945L10.203 14.922L7.10547 11.457L11.6055 10.8945L13.8555 6.39453Z",
    fill: "url(#paint2_linear_462_16814)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 6.17092L13.8555 5.2765L13.4083 6.17092L11.2779 10.4316L7.04345 10.9609L6.09705 11.0792L6.7327 11.7903L9.66959 15.0756L8.86258 19.8105L8.69685 20.7829L9.57908 20.3417L13.8555 18.2035L18.1319 20.3417L19.0125 20.7821L18.8485 19.8112L18.0485 15.0756L20.9786 11.7898L21.6125 11.079L20.6675 10.9609L16.433 10.4316L14.3027 6.17092Z",
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_16814",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_16814",
    x1: 13.4419,
    y1: 3.80664,
    x2: 13.4419,
    y2: 22.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_462_16814",
    x1: 13.8555,
    y1: 10.7325,
    x2: 13.8555,
    y2: 19.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.d1ac4b56af6c3de4e44910aa8b8fab33.svg";
export { ForwardRef as ReactComponent };